import { Checkout, CheckoutProvider } from "paytm-blink-checkout-react";
import React, { Component } from "react";
import { vasthuUrl } from "../component/Api";
import CONFIG from "../component/PaymentConfig";
import { paymentContext } from "../context/PaymentContext";

const USE_EXISTING_CHECKOUT_INSTANCE = "Use existing checkout instance : ";
const scriptElement = document.createElement("script");
// const accessToken = window.sessionStorage.getItem("token");
const lang = localStorage.getItem("i18nextLng");
console.log("Lang", lang);

class BookConsultation extends Component {
  textAreaRef = React.createRef();

  static contextType = paymentContext;

  constructor(props) {
    super(props);
    this.state = {
      config: this.appendHandler(CONFIG),
      showCheckout: true,
      openInPopup: true,
      checkoutJsInstance: null,
      token: null,
      offerId: null,
      userId: null,
      profUuid: null,
      slotId: null,
      serviceId: null,
    };
  }

  componentDidMount = () => {
    CONFIG.data.token = this.props.txnToken;
    CONFIG.data.orderId = this.props.orderId;
    CONFIG.data.amount = this.props.amount;
    const token = window.sessionStorage.getItem("token");
    const offerId = this.props.offerId;
    const userId = this.props.userId;
    const profUuid = this.props.consultantId;
    const slotId = this.props.slotId;
    const serviceId = this.props.serviceId;
    this.setState({
      config: this.appendHandler(CONFIG),
      token,
      offerId,
      userId,
      profUuid,
      slotId,
      serviceId,
    });
  };

  appendHandler(config) {
    const newConfig = { ...config };
    newConfig.handler = {
      notifyMerchant: this.notifyMerchantHandler,
      transactionStatus: this.transactionStatusHandler,
    };

    console.log("NEW CONFIG", newConfig);
    return newConfig;
  }

  notifyMerchantHandler = (eventType, data) => {
    console.log("FROM NOTIFY HANDLER METHOD");
    console.log("MERCHANT NOTIFY LOG", eventType, data);
  };

  transactionStatusHandler = async (paymentStatus, eventType) => {
    window.Paytm.CheckoutJS.close();

    console.log("PAYMENT RESPONSE ", paymentStatus);

    await vasthuUrl
      .post(
        `vasthu/verifyPaymentStatus/`,
        {
          orderId: paymentStatus.ORDERID,
          currency: paymentStatus.CURRENCY,
          userUuid: this.state.userId,
          offerId: this.props.offerId,
        },
        {
          headers: {
            Authorization: `Bearer ${this.state.token}`,
          },
        }
      )
      .then((res) => {
        console.log("Payment db save", res.data);
        console.log("OFFER ID  ", this.props.offerId, this.state.offerId);
        if (res.data.status === "TXN_SUCCESS") {
          vasthuUrl
            .post(
              "subscription/buyVasthuOffer",
              {
                orderId: paymentStatus.ORDERID,
                userUuid: this.state.userId,
                offerId: this.props.offerId,
                paymentStatus: true,
              },
              {
                headers: {
                  Authorization: `Bearer ${this.state.token}`,
                },
              }
            )
            .then((resp) => {
              console.log("afterbuy -resp - subscriptionId" + resp.data.id);
              console.log("Payment status changed to true");

              vasthuUrl
                .post(
                  `blockslot`,
                  {
                    userUuid: this.state.userId,
                    consultantUuid: this.state.profUuid,
                    slotId: this.state.slotId,
                    subscriptionId: resp.data.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer ${this.state.token}`,
                    },
                  }
                )
                .then((response) => {
                  console.log("afterblock" + response.data.id);
                  console.log(response.data.message);
                  if (response.data.message === "SUCCESS") {
                    vasthuUrl
                      .post(
                        `bookslot`,
                        {
                          userUuid: this.state.userId,
                          consultantUuid: this.state.profUuid,
                          slotId: this.state.slotId,
                          offerId: this.state.offerId,
                          serviceId: this.state.serviceId,
                          subscriptionId: resp.data.id,
                          lng: lang,
                        },
                        {
                          headers: {
                            Authorization: `Bearer ${this.state.token}`,
                          },
                        }
                      )
                      .then((result) => {
                        console.log("MSG", result.data.message);
                        console.log("RES", result.data);
                        if (result.data.message === "SUCCESS" && resp.data.id) {
                          vasthuUrl
                            .get(
                              `/subscription/useVasthuOffer/${resp.data.id}`,
                              {
                                headers: {
                                  Authorization: `Bearer ${this.state.token}`,
                                },
                              }
                            )
                            .then((rs) => {
                              console.log(
                                "offer subscription redeem count used",
                                rs.data.message
                              );
                              this.props.navigate("/consultantbooklist");
                            });
                        }
                      });
                  } else {
                    console.log("Book Failed");
                  }
                });
            });
        } else {
          vasthuUrl
            .post(
              "subscription/buyVasthuOffer",
              {
                orderId: paymentStatus.ORDERID,
                userUuid: this.state.userId,
                offerId: this.props.offerId,
                paymentStatus: false,
              },
              {
                headers: {
                  Authorization: `Bearer ${this.state.token}`,
                },
              }
            )
            .then((res) => {
              console.log("Payment status changed to false");
            });
        }
      });

    // this.setState({showCheckout : false});

    // this.setState({showCheckout : false});
  };

  renderUpdateConfig = () => {
    this.setState({
      config: this.getUpdatedConfig(),
    });
  };

  getUpdatedConfig() {
    const config = this.parse(this.textAreaRef.current.value);

    return this.appendHandler(config);
  }

  parse(value) {
    try {
      return JSON.parse(value);
    } catch (err) {
      console.error("Invalid config JSON");
      return {};
    }
  }

  toggleOpenInPopup = () => {
    this.setState((prevState, _) => ({
      openInPopup: !prevState.openInPopup,
    }));
  };

  toggleCheckout = () => {
    this.setState((prevState, _) => ({
      showCheckout: !prevState.showCheckout,
    }));
  };

  loadCheckoutScript = () => {
    console.log("MID", CONFIG.merchant.mid);
    const url =
      "https://pgp-hotfix.paytm.in/merchantpgpui/checkoutjs/merchants/";

    scriptElement.id = "paytmCheckout";
    scriptElement.async = true;
    scriptElement.src = url.concat(CONFIG.merchant.mid);
    scriptElement.type = "application/javascript";
    scriptElement.onload = () => {
      const checkoutJsInstance = this.getCheckoutJsObj();

      console.log("JS OBJ 1", checkoutJsInstance);

      if (checkoutJsInstance && checkoutJsInstance.onLoad) {
        checkoutJsInstance.onLoad(() => {
          this.setState({
            config: this.getUpdatedConfig(),
            checkoutJsInstance,
          });

          console.log("RESPONSE DATA", this.state.config, checkoutJsInstance);
        });
        console.log("JS OBJ 2", checkoutJsInstance);
      } else {
        console.error(USE_EXISTING_CHECKOUT_INSTANCE + "onload not available!");
      }
    };
    scriptElement.onerror = (error) => {
      console.error(USE_EXISTING_CHECKOUT_INSTANCE + "script load fail!");
    };
  };

  getCheckoutJsObj() {
    if (window && window.Paytm && window.Paytm.CheckoutJS) {
      console.log("CHECKOUT JS 2", this.state.checkoutJsInstance);

      return window.Paytm.CheckoutJS.invoke();
    } else {
      console.error(
        USE_EXISTING_CHECKOUT_INSTANCE + "Checkout instance not found!"
      );
    }

    return null;
  }

  render() {
    // const { showCheckout, openInPopup, config } = this.state;
    // const textAreaVal = JSON.stringify(config, null, 4);
    const { openInPopup } = this.state;
    console.log("CHECKOUT JS", this.state.checkoutJsInstance);
    return (
      <div>
        {/* <textarea cols="50"
          rows="25"
          defaultValue={textAreaVal}
          ref={this.textAreaRef} /> */}
        {/* <div> */}
        {/* <button type="button" onClick={this.toggleCheckout}>
            Toggle Checkout Screen
          </button> */}
        {/* <button type="button"
            onClick={this.renderUpdateConfig}>
            Re-render updated config
          </button>
          <button type="button"
            onClick={this.loadCheckoutScript}>
            Use existing checkout instance
          </button> */}
        {/* <input
            type="checkbox"
            onClick={this.toggleOpenInPopup}
            defaultChecked={openInPopup}
          ></input>{" "}
          Open in popup
        </div> */}
        <br />

        {/* <div>
          <b>CHECKOUT VISIBILITY :</b> {showCheckout.toString()}
        </div> */}
        <CheckoutProvider
          config={this.state.config}
          checkoutJsInstance={this.state.checkoutJsInstance}
          openInPopup={openInPopup}
          env="STAGE"
        >
          <Checkout />
        </CheckoutProvider>
      </div>
    );
  }
}

export default BookConsultation;
